import { Suspense } from 'react'
import { AgGridReact } from 'ag-grid-react'
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community'
import { useUploadHistory } from './useUploadHistory'
import { Grid, Button, Tooltip } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { RefreshIcon } from '@enterprise-ui/icons'
import TablePlaceholder from './TablePalceholder'
import { getFormattedLocalTime } from '../../../utilities/uploadHistoryGrid'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import '../../../styles/gridAgAlpine.scss'

ModuleRegistry.registerModules([AllCommunityModule])
const UploadHistory = ({ isFileuploaded }) => {
  const {
    gridRef,
    getRowId,
    gridOptions,
    defaultColDef,
    columnDefs,
    rowData,
    updateGrid,
    loading,
    timestamp,
    onGridReady,
    autoRefresh,
  } = useUploadHistory(isFileuploaded) // Pass key to hook

  const gridHeight = 'calc(100vh - 470px)'
  const gridWidth = '100%'
  const overlayLoadingTemplate = 'Loading Upload History...'
  const overlayNoRowsTemplate = `<div>No recent uploads! <p>Upload a spreadsheet to setup or maintain </br>item data and track file history here.</p></div>`
  return (
    <Suspense fallback="loading VeGrid">
      <Grid.Container
        justify="space-between"
        className="hc-mt-normal hc-mb-normal"
      >
        <Grid.Item>
          <h2 className="font-weight-500">Upload History</h2>
          <p className="hc-clr-grey01">
            Track upload requests from the last 3 months. In case of rejections,
            click on ‘Download rejected items’, correct errors, and re-upload
            the file.
          </p>
        </Grid.Item>
        <Grid.Item className="refresh-container">
          <span>
            {autoRefresh && <>Statuses auto-refresh every 1 min. </>}
            Last refreshed {getFormattedLocalTime(timestamp)}
            <Tooltip content="Refresh status" location="top">
              <Button
                onClick={updateGrid}
                type="ghost"
                className="hc-ml-min hc-mt-none"
                aria-label="Refresh Upload History"
              >
                <EnterpriseIcon icon={RefreshIcon} />
              </Button>
            </Tooltip>
          </span>
        </Grid.Item>
      </Grid.Container>
      {loading ? (
        <TablePlaceholder />
      ) : (
        <div
          id="card-upload-history"
          className="ag-theme-alpine"
          style={{
            height: gridHeight,
            width: gridWidth || '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          }}
        >
          <AgGridReact
            gridRef={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            getRowId={getRowId}
            width={gridWidth}
            height={gridHeight}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            overlayLoadingTemplate={overlayLoadingTemplate}
            overlayNoRowsTemplate={overlayNoRowsTemplate}
          />
        </div>
      )}
    </Suspense>
  )
}
export default UploadHistory
